import { render, staticRenderFns } from "./ContentChoose.vue?vue&type=template&id=6b71426a&scoped=true&"
import script from "./ContentChoose.vue?vue&type=script&lang=js&"
export * from "./ContentChoose.vue?vue&type=script&lang=js&"
import style0 from "./ContentChoose.vue?vue&type=style&index=0&id=6b71426a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b71426a",
  null
  
)

export default component.exports